import { useState } from "react";
import { useFetch } from "../lib/api";
import { useMember } from "../lib/member";
import { PageHeader, Empty } from "../components/shared";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { ContractorFilings, OwnFilings, OwnPayroll, Approvers, StateSettings } from "../components/PeParts";
import { ContractorScorecard, RuleHistory } from "../components/PeScore";
import { ContractorExportBar } from "../components/PeExport";
import { HoldReport } from "../components/HoldReport";

export default function PeFilings() {
  const { me } = useMember();
  const { data: employers, reload } = useFetch("/pe/employers");
  const [pick, setPick] = useState("");
  const eid = me?.role === "employer" ? me.employer_id : pick || employers?.[0]?.id;
  const emp = (employers || []).find((e) => e.id === eid);
  return (
    <div>
      <PageHeader eyebrow="Principal employer" title="Statutory filings" desc="Contractors' PF/ESIC filings, your own PF ECR, ESIC, Professional Tax, LWF and CLRA returns, and the approvers who sign them off.">
        {me?.role !== "employer" && (employers || []).length > 0 && (
          <select className="c-input w-64" value={eid || ""} onChange={(e) => setPick(e.target.value)} data-testid="pe-employer-select">
            {employers.map((e) => <option key={e.id} value={e.id}>{e.company_name}</option>)}</select>)}
      </PageHeader>
      {employers?.length === 0 && <Empty text="Add a principal employer first." />}
      {emp && <StateSettings key={`${eid}${emp.state}`} emp={emp} onSaved={reload} />}
      {emp && <ContractorExportBar eid={eid} />}
      {emp && (
        <Tabs defaultValue="contractors" key={eid}>
          <TabsList className="bg-[#121824] border border-[#1F2A3E] mb-5">
            {[["contractors", "Contractor filings"], ["scorecard", "Scorecard"], ["holds", "Holds"], ["own", "Own filings"], ["payroll", "Own payroll data"], ["approvers", "Approvers"],
              ...(["admin", "employer"].includes(me?.role) ? [["rules", "Rule history"]] : [])].map(([k, l]) => (
              <TabsTrigger key={k} value={k} data-testid={`pe-tab-${k}`}>{l}</TabsTrigger>))}
          </TabsList>
          <TabsContent value="contractors"><ContractorFilings eid={eid} /></TabsContent>
          <TabsContent value="scorecard"><ContractorScorecard eid={eid} /></TabsContent>
          <TabsContent value="holds"><HoldReport eid={eid} /></TabsContent>
          <TabsContent value="rules"><RuleHistory key={JSON.stringify([emp.state, emp.pt_due_day, emp.rule_overrides])} eid={eid} /></TabsContent>
          <TabsContent value="own"><OwnFilings eid={eid} /></TabsContent>
          <TabsContent value="payroll"><OwnPayroll eid={eid} /></TabsContent>
          <TabsContent value="approvers"><Approvers eid={eid} initial={emp.approvers} onSaved={reload} /></TabsContent>
        </Tabs>)}
    </div>
  );
}
